export default __webpack_public_path__ + "static/media/gallery_01.a1c36467.jpg";